import React, { useState, useEffect, useCallback } from 'react';
import { kbCurationAPI } from '../../services/api';
import ProposalApproveModal from './ProposalApproveModal';
import CurationStatsBar from './CurationStatsBar';

export default function KBCurationView() {
  const [tab, setTab] = useState('plantilla');
  const [status, setStatus] = useState('pending');
  const [verDescartados, setVerDescartados] = useState(false);
  const [proposals, setProposals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [approving, setApproving] = useState(null);
  const [selected, setSelected] = useState(new Set());
  const [continuo, setContinuo] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const load = useCallback(async () => {
    setLoading(true);
    setSelected(new Set());
    try {
      const st = verDescartados ? 'rejected' : status;
      const res = await kbCurationAPI.listProposals({ tipo: tab, status: st });
      setProposals(res.data || []);
    } catch (e) { console.error('[KBCuration] load error', e); setProposals([]); }
    finally { setLoading(false); }
  }, [tab, status, verDescartados]);

  useEffect(() => { load(); }, [load]);
  const refresh = () => { setRefreshKey(k => k + 1); load(); };

  const toggleSel = (id) => setSelected(s => { const n = new Set(s); n.has(id) ? n.delete(id) : n.add(id); return n; });

  const bulkApprove = async () => {
    const ids = [...selected];
    const r = await kbCurationAPI.bulkApprove(ids.length ? { ids } : {});
    alert(`Aprobadas: ${r.approved ?? 0}${r.failed ? `, fallidas: ${r.failed}` : ''}`);
    refresh();
  };
  const toggleContinuo = async () => { const v = !continuo; await kbCurationAPI.setConfig(v); setContinuo(v); };

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-xl font-bold">Curacion de KB</h1>
        <div className="flex gap-2 items-center">
          <label className="flex items-center gap-1 text-sm mr-2">
            <input type="checkbox" checked={continuo} onChange={toggleContinuo} /> Mineria continua
          </label>
          <button onClick={() => kbCurationAPI.rescan(60).then(() => alert('Re-escaneo encolado'))}
                  className="px-3 py-1.5 bg-blue-600 text-white rounded text-sm">Re-escanear</button>
        </div>
      </div>
      <CurationStatsBar refreshKey={refreshKey} />
      <div className="flex gap-2 mb-4 items-center">
        <button onClick={() => setTab('plantilla')} className={`px-3 py-1.5 rounded ${tab==='plantilla'?'bg-gray-800 text-white':'bg-gray-100'}`}>Plantillas</button>
        <button onClick={() => setTab('qa_pair')} className={`px-3 py-1.5 rounded ${tab==='qa_pair'?'bg-gray-800 text-white':'bg-gray-100'}`}>Pares Q-R</button>
        {!verDescartados && selected.size > 0 && (
          <button onClick={bulkApprove} className="px-3 py-1.5 bg-green-600 text-white rounded text-sm">Aprobar {selected.size} (solo plantillas sin match)</button>
        )}
        <label className="ml-auto flex items-center gap-1 text-sm">
          <input type="checkbox" checked={verDescartados} onChange={e=>setVerDescartados(e.target.checked)} /> Ver descartados
        </label>
      </div>
      {loading ? <p>Cargando...</p> : (
        <table className="w-full text-sm border">
          <thead><tr className="bg-gray-50 text-left">
            <th className="p-2 w-8"></th>
            <th className="p-2">Texto</th><th className="p-2">Cat</th><th className="p-2">Frec</th>
            <th className="p-2">Agentes</th><th className="p-2">Conf</th><th className="p-2">Accion</th></tr></thead>
          <tbody>
            {proposals.map(p => (
              <tr key={p.id} className="border-t align-top">
                <td className="p-2">{!verDescartados && <input type="checkbox" checked={selected.has(p.id)} onChange={()=>toggleSel(p.id)} />}</td>
                <td className="p-2 max-w-md">{(p.texto_original || '').slice(0,180)}{(p.texto_original||'').length>180?'...':''}
                  {p.match_kb_qa_id && <span className="ml-1 text-amber-600">~#{p.match_kb_qa_id}</span>}
                  {p.match_common_question_id && <span className="ml-1 text-amber-600">~cq#{p.match_common_question_id}</span>}
                  {verDescartados && p.razon_descarte && <div className="text-xs text-gray-400">descartada: {p.razon_descarte}</div>}</td>
                <td className="p-2">{p.categoria}</td>
                <td className="p-2">{p.frecuencia}</td>
                <td className="p-2">{(p.agentes_fuente||[]).join(', ')}</td>
                <td className="p-2">{typeof p.confidence === 'number' ? p.confidence.toFixed(2) : ''}</td>
                <td className="p-2 whitespace-nowrap">
                  {verDescartados
                    ? <button onClick={()=>kbCurationAPI.rescue(p.id).then(refresh)} className="text-blue-600">Rescatar</button>
                    : <>
                        <button onClick={()=>setApproving(p)} className="text-green-600 mr-2 font-bold">OK</button>
                        <button onClick={()=>kbCurationAPI.reject(p.id).then(refresh)} className="text-red-600 font-bold">X</button>
                      </>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {approving && <ProposalApproveModal proposal={approving} onClose={()=>setApproving(null)} onDone={()=>{ setApproving(null); refresh(); }} />}
    </div>
  );
}
